"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _ImageWithDescription = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/ImageWithDescription");

var _ImageWithDescription2 = _interopRequireDefault(_ImageWithDescription);

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = (0, _glamor.css)({
  flexWrap: "wrap",
  width: "100%",
  margin: "auto",
  justifyContent: "center",
  boxSizing: "border-box",
  textAlign: "center",
  padding: "8vw !important"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  padding: "15vw !important"
}));

var hr = (0, _glamor.css)({
  width: "15%",
  margin: "13rem auto 14rem",
  display: "block",
  border: "none",
  height: "4px",
  backgroundBlendMode: "normal, color",
  backgroundImage: "linear-gradient(-90deg,#2b98f0, #6497bf)"
}, (0, _css.maxWidth)(_css.breakpoints.super4k)({
  height: "3px",
  margin: "11rem auto 12rem",
  width: "16%"
}), (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
  margin: "7rem auto 8rem",
  width: "14.88%"
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  margin: "4rem auto 5rem",
  height: "2px",
  width: "14.88%"
}), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  margin: "3rem auto 3.5rem",
  width: "20%"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({}));
var subHeading = (0, _glamor.css)(_fonts.superH2, {
  textTransform: "uppercase",
  margin: "auto",
  marginBottom: "6rem",
  textAlign: "center",
  color: _css.colors.gray
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  marginBottom: "3rem"
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  marginBottom: "2rem"
}));
var heading = (0, _glamor.css)(_fonts.H2, {
  textTransform: "uppercase",
  display: "flex",
  justifyContent: "center",
  margin: "auto",
  textAlign: "center",
  height: "auto",
  fontStretch: "normal",
  color: "#ffffff"
});

var section = (0, _glamor.css)({
  paddingTop: "0 !important",
  paddingBottom: "0 !important"
});

var inner = (0, _glamor.css)({
  width: "100%",
  maxWidth: "60vw !important",
  padding: "0px !important"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  maxWidth: "unset!important"
}));

var innerContainer = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  flexDirection: "column"
}));

var superIcon = function superIcon(url) {
  return (0, _glamor.css)((0, _css.bgContain)(url), {
    display: "inline-block",
    width: "3.75vw",
    height: "3.75vw",
    marginBottom: 33
  }, (0, _css.maxWidth)(_css.breakpoints.large)({
    width: "5.5vw",
    height: "5.5vw",
    marginBottom: "2em"
  }), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    width: "6.5vw",
    height: "6.5vw"
  }), (0, _css.maxWidth)(_css.breakpoints.medium)({
    width: "8vw",
    height: "8vw"
  }), (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
    width: "10vw",
    height: "10vw"
  }));
};

var DescriptionWith3Columns = function DescriptionWith3Columns(props) {
  return _react2.default.createElement(
    "div",
    { className: container },
    props.superIcon && _react2.default.createElement("span", superIcon(props.superIcon, true)),
    props.title && _react2.default.createElement(
      "div",
      { className: subHeading },
      props.title
    ),
    _react2.default.createElement(
      "div",
      { className: heading },
      props.headingBeforeBreak,
      _react2.default.createElement("br", null),
      props.headingAfterBreak
    ),
    _react2.default.createElement("hr", { className: hr }),
    _react2.default.createElement(_Section2.default, {
      hr: props.hr,
      className: section,
      Indie: true,
      innerClassName: inner,
      title: "",
      subTitle: props.desc,
      formattedText: props.formattedText,
      footer: props.footer,
      formattedFooter: props.formattedFooter,
      content: _react2.default.createElement(
        "div",
        { className: innerContainer },
        props.columns.map(function (c, key) {
          return _react2.default.createElement(_ImageWithDescription2.default, (0, _extends3.default)({ key: key }, c));
        })
      )
    })
  );
};
exports.default = DescriptionWith3Columns;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Marketing/DescriptionWith3Columns/index.jsx
// module id = 2566
// module chunks = 0